module.exports = __webpack_public_path__ + "static/media/referral-code.fb3e9e7e.webp";